import Vue from 'vue'
import VueRouter from 'vue-router'
import Index from '../views/index/index.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Index',
    component: Index
  },
  {
    path: '/declare',
    name: 'Declare',
    component: () => import('../views/index/declare.vue')
  }, 
  {
    path: '/camp',
    name: 'Camp',
    component: () => import('../views/index/camp.vue')
  },
  {
    path: '/my',
    name: 'My',
    component: () => import('../views/my/index.vue')
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/my/login.vue')
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('../views/my/register.vue')
  },
  {
    path: '/forget',
    name: 'Forget',
    component: () => import('../views/my/forget.vue')
  },
  {
    path: '/manual',
    name: 'Manual',
    component: () => import('../views/my/manual.vue')
  },
  {
    path: '/download',
    name: 'Download',
    component: () => import('../views/my/download.vue')
  },
  {
    path: '/agreement',
    name: 'Agreement',
    component: () => import('../views/my/agreement.vue')
  },
  {
    path: '/test',
    name: 'Test',
    component: () => import('../views/my/test.vue')
  },
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

// 解决Vue-Router升级导致的Uncaught(in promise) navigation guard问题
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}

//全局守卫
router.beforeEach((to, from, next)=> {
  let user = window.localStorage.getItem('user');
  if(!user) {
    if(to.name == 'Declare' || to.name == 'Manual'|| to.name=='Camp') {
      next({path: '/login'})
    }else {
      next();
    }
  }else {
    next();    
  }
});
export default router
